import React from 'react';
import { haveMarkup, markup2text } from '~/modules/helpers';

// prettier-ignore
export const html2textCellRender = props => {
    const str = props.value;
    return str
        ? <div className="ag-html-text text-truncate">
            {
                haveMarkup(str)
                    ? markup2text(str)
                    : str
            }
          </div>
        : '';
};
